import styled from "styled-components"
import { Colors } from 'styles/app-styles'
import DataTable_s from "components/table/data-table-styles"

export const RecoveryPools_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const RecoveryPoolsDetailTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  padding-top: 90px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  .p-datatable-thead > tr:last-child {
    height: 40px;
  }

  .p-datatable-scrollable-header {
    background: ${Colors.white};
  }

  .p-datatable-scrollable-header-table {
    background: ${Colors.white};
    position: fixed;
    z-index: 2;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    margin-top: 39px;
  }

  .p-datatable-tbody > tr > td {
    padding-left: 5px;
  }
`

export const FormRow_s = styled.div`
  background: ${Colors.white};
  display: flex;
  padding: 20px;
  position: fixed;
  width: 100%;
  z-index: 2;
  label {
    margin-bottom: 10px;
  }
  .percent-line-radio-buttons {
    margin-top: 10px;
  }
  > div {
    margin-right: 30px;
  }
  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
  }
`
